import React from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';

class TourToday extends React.Component {
  getToday(today) {
    const tour = this.props.tour;
    if (today.isBetween(tour.start, tour.end)) {
      if (tour.tour_stops) {
        const stops = tour.tour_stops.length;
        for (let i = 0; i < stops; i++) {
          const stop = tour.tour_stops[i];
          if (today.isBetween(stop.start, stop.end)) {
            return `${stop.place.city}, ${stop.place.state}`;
          }
        }
      }
      return 'Ongoing';
    }
    if (today.isBefore(tour.start)) {
      return `Begins ${moment(tour.start).fromNow()}`;
    }
    if (today.isAfter(tour.end)) {
      return `Ended ${moment(tour.end).fromNow()}`;
    }
    return 'No dates set yet.';
  }

  render() {
    return (
      <div className="tour-today text-center">
        {this.getToday(moment())}
      </div>
    );
  }
}
export default TourToday;



// WEBPACK FOOTER //
// src/routes/tours/components/TourToday.js